import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const addSuccessAlert = (messageKey, beta, titleKey = 'app.betas.success.joinedSuccess') => {
  FloatingAlertStore.addAlert({
    message: I18n.text(messageKey, {
      beta: I18n.SafeString(beta)
    }),
    titleText: I18n.text(titleKey),
    type: 'success'
  });
};
export const addErrorAlert = titleKey => {
  FloatingAlertStore.addAlert({
    message: I18n.text('app.betas.errors.refresh'),
    titleText: I18n.text(titleKey),
    type: 'danger'
  });
};